import * as React from 'react';
import { Flex, FlexItem } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Small } from '../../../designSystem/typography/Body';
import { H3 } from '../../../designSystem/typography/Heading';
import { LinkButton } from '../../../designSystem/button/LinkButton';

type DashboardCardContentProps = {
    title: string;
    activityStatus: string;
    activityLink: string;
    activityTitle: string;
    createNew?: boolean;
}

export function DashboardCardContent(props: DashboardCardContentProps ): JSX.Element {
    return (
        <Flex flexDirection="column" gap={16}>
            <Flex flexDirection="column" gap={4}>
                <H3>{props.title}</H3>
                <Small>{props.activityStatus}</Small>
            </Flex>
            
            <FlexItem>
                <LinkButton variant={props.createNew ? "filled" : "outlined"} href={props.activityLink} text={props.activityTitle} icon={props.createNew ? 'add_circle' : 'arrows_chevron_chevronForward'} iconPosition='right'/>
            </FlexItem>
        </Flex>
    );
}